import { create } from 'zustand';
import { MessageWithLoader } from '@/types/streaming.types';

export enum StreamStatus {
  STARTING = "STARTING",
  STREAMING = "STREAMING",
  COMPLETED = "COMPLETED",
  IDLE = "IDLE",
  TRANSITIONING = "TRANSITIONING",
}

interface ChatStore {
  messages: MessageWithLoader[];
  addMessage: (message: MessageWithLoader) => void;
  setMessages: (messages: MessageWithLoader[]) => void;
  streamStatus: StreamStatus;
  setStreamStatus: (streamStatus: StreamStatus) => void;
  updateMessage: (id: string, content: string) => void;
  appendToMessage: (id: string, content: string) => void;
  updateMessageSuggestions: (id: string, suggestions: string[]) => void;
  removeMessage: (id: string) => void;
  transitionFromLoader: (loaderId: string, newMessage: MessageWithLoader) => void;
}

export const useChatStore = create<ChatStore>((set) => ({
  messages: [],
  addMessage: (message: MessageWithLoader) => {
    set((state) => ({ messages: [...state.messages, message] }));
  },
  setMessages: (messages: MessageWithLoader[]) => {
    set({ messages });
  },
  streamStatus: StreamStatus.IDLE,
  setStreamStatus: (streamStatus: StreamStatus) => {
    set({ streamStatus });
  },
  updateMessage: (id: string, content: string) => {
    set((state) => ({ 
      messages: state.messages.map((msg) => 
        msg.id === id 
          ? { 
              ...msg, 
              content: content 
            } 
          : msg
      ) 
    }));
  },
  appendToMessage: (id: string, content: string) => {
    set((state) => ({ 
      messages: state.messages.map((msg) => 
        msg.id === id 
          ? { 
              ...msg, 
              content: msg.content + content 
            } 
          : msg
      ) 
    }));
  },
  updateMessageSuggestions: (id: string, suggestions: string[]) => {
    set((state) => ({ 
      messages: state.messages.map((msg) => 
        msg.id === id 
          ? { 
              ...msg, 
              suggestions: suggestions 
            } 
          : msg
      ) 
    }));
  },
  removeMessage: (id: string) => {
    set((state) => ({ messages: state.messages.filter((msg) => msg.id !== id) }));
  },
  transitionFromLoader: (loaderId: string, newMessage: MessageWithLoader) => {
    set((state) => ({
      messages: state.messages.map((msg) => 
        msg.id === loaderId 
          ? { ...newMessage, id: loaderId }
          : msg
      ),
      streamStatus: StreamStatus.STREAMING
    }));
  },
})); 
